import { Pill, type PillSize } from "@src/appV2/redesign/system/ui-components";

interface ShortLeadTimePillProps {
  size?: PillSize;
  shouldLeaveNow: boolean;
}

export function ShortLeadTimePill(props: ShortLeadTimePillProps) {
  const { size = "small", shouldLeaveNow } = props;

  return (
    <Pill
      size={size}
      variant="filled"
      label={shouldLeaveNow ? "Leave now" : "Starts soon"}
      backgroundColor={(theme) => theme.palette.intent?.success.background}
      color={(theme) => theme.palette.intent?.success.text}
      iconColor={(theme) => theme.palette.intent?.success.icon}
      iconType="clock-filled"
      sx={{
        width: "fit-content",
      }}
    />
  );
}
